"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint prefer-arrow-callback:0 */
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const modal_1 = require("src/context/modal");
// import {ImageAttachment} from '../types';
const attachment_image_styles_1 = __importDefault(require("./attachment-image.styles"));
const b = b_1.default.with('attachment-image');
// type ImageAttachmentProps = Pick<ImageAttachment, 'url'>;
const ImageAttachmentComponent = (props, ref) => {
    const { url, children } = props;
    const [isfullyRendered, setIsFullyRendered] = (0, react_2.useState)(false);
    const { showImageModal, theme } = (0, modal_1.useModalContext)();
    const isVideoPreview = theme === 'video';
    const handleImageLoad = (e) => {
        const image = e.target;
        const { width, height, naturalWidth, naturalHeight } = image;
        if (width === naturalWidth && height === naturalHeight) {
            setIsFullyRendered(true);
        }
    };
    const handleOnClick = url => {
        if (!isfullyRendered && !isVideoPreview) {
            showImageModal(url);
            return;
        }
        return false;
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: attachment_image_styles_1.default }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('wrapper', { zoomable: !isfullyRendered }) }, { children: [!isfullyRendered && !isVideoPreview && ((0, jsx_runtime_1.jsx)("div", { className: b('zoom'), onClick: () => handleOnClick(url) })), (0, jsx_runtime_1.jsx)("img", { ref: ref, src: url, onClick: () => handleOnClick(url), onLoad: handleImageLoad })] })), children] })));
};
exports.default = (0, react_2.forwardRef)(ImageAttachmentComponent);
